<!--
    描述：新增编码规则弹框
    时间：2020-07-30
    Created by yefan
-->
<template>
	<div class="h100 add-code-main">
		<el-form :model="formDynamic"
				 :rules="formValidate"
				 ref="codeForm"
				 label-width="120px">
			<el-form-item label="规则类型"
						  prop="tag"
						  :show-message="false">
				<el-row>
					<el-col :span="22">
						<el-select v-model="formDynamic.tag"
								   placeholder="请选择">
							<el-option v-for="(item, index) in typeList"
									   :key="'类型' + index"
									   :label="item.sname"
									   :value="item.sname">
							</el-option>
						</el-select>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item v-for="(item, index) in formDynamic.items"
						  v-if="item.status"
						  :key="index"
						  :label="'类型 '">
				<el-row>
					<el-col :span="5">
						<el-select v-model="item.xmLxSelect"
								   @change="xmLxChange($event,index)"
								   seletIndex="item.index"
								   clearable>
							<el-option v-for="type in item.typeList3"
									   :value="type.label"
									   :key="type.value">{{
                                type.label }}
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="5"
							id="type3"
							v-show="item.lxInput3Show"
							style="margin-left: 5px">
						<el-input id="lxInput3"
								  v-model="item.xmLxInput"
								  :disabled="disable_lx"
								  placeholder="Enter something..."></el-input>
					</el-col>
					<el-col :span="3"
							style="text-align:center;">连接符</el-col>
					<el-col :span="5">
						<el-select v-model="item.xmConnector_1"
								   clearable>
							<el-option v-for="connector in item.connector3_1"
									   :value="connector.label"
									   :key="connector.value">{{ connector.label }}
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="4"
							style="text-align:center;">
						<el-button type="warning"
								   plain
								   size="small"
								   @click="handleRemove(index)">Delete</el-button>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item style="width:100%;margin-left:1px">
				<el-row>
					<el-col :span="2">
						<el-button type="primary"
								   size="small"
								   @click="handleAdd"
								   icon="plus-round">增加 类型</el-button>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item label="流水号"
						  prop="groupIds"
						  :show-message="false">
				<el-row>
					<el-col :span="22">
						<el-select v-model="formDynamic.serialNo"
								   placeholder="请选择">
							<el-option v-for="(item, index) in serialNoList"
									   :key="'类型' + index"
									   :label="item.sname"
									   :value="item.sname">
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="2"><span style="margin-left: 10px"></span>位</el-col>
				</el-row>
			</el-form-item>
			<el-form-item label="规则"
						  :show-message="false">
				<el-row>
					<el-col :span="22">
						<el-input v-model="guize"
								  disabled
								  autocomplete="off"></el-input>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item label="启用日期"
						  prop="startDate"
						  :show-message="false">
				<el-row>
					<el-col :span="22">
						<el-date-picker v-model="formDynamic.startDate"
										type="date"
										format="yyyy 年 MM 月 dd 日"
										value-format="yyyy-MM-dd"
										placeholder="请选择日期">
						</el-date-picker>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item label="适用单位"
						  prop="parentName"
						  :show-message="false">
				<el-row>
					<el-col :span="22">
						<el-input v-model="formDynamic.parentName"
								  disabled
								  autocomplete="off">
							<el-button slot="append"
									   icon="el-icon-plus"
									   @click="selectModal"></el-button>
						</el-input>
					</el-col>
				</el-row>
			</el-form-item>
		</el-form>
        
		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :close-on-click-modal="false"
				   append-to-body>
			<!-- 弹窗组件 -->
			<selectDeptDialog ref="selectDept"
							  @on-success="selectDept"></selectDeptDialog>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   @click="addDept">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import selectDeptDialog from './select_dept_dialog'
import { saveSysCode } from 'api/system/sys.js'

export default {
	components: { selectDeptDialog },
	data() {
		return {
			dis: false,
			selectShow: false,
			tempPid: '',
			tempParentName: '',
			rules: [],
			index: 1,
			formDynamic: {
				id: '',
				tag: '',
				parentName: '',
				parentIds: [],
				serialNo: '',
				companyId: '',
				items: [
					{
						index: 1,
						status: 1,
						lxInput3Show: false,
						xmLxInput: '',
						xmLxSelect: '',
						xmConnector_1: '',
						typeList3: [
							{ value: '1', label: 'String' },
							{ value: '2', label: 'YYYY' },
							{ value: '3', label: 'MM' },
							{ value: '4', label: 'DD' }
						],
						connector3_1: [
							{ value: '1', label: '*' },
							{ value: '2', label: '/' },
							{ value: '3', label: '_' },
							{ value: '4', label: '+' },
							{ value: '5', label: '-' },
							{ value: '6', label: '#' }
						]
					}
				],
				startDate: ''
			},
			formValidate: {
				tag: [
					{
						required: true,
						message: '请选择新增规则类型',
						trigger: 'blur'
					}
				],
				parentName: [
					{
						required: true,
						message: '请选择适用单位',
						trigger: 'blur'
					}
				],
				serialNo: [
					{ required: true, message: '请选择流水号', trigger: 'blur' }
				],
				startDate: [
					{
						required: true,
						message: '请选择启用日期',
						trigger: 'blur'
					}
				]
			},
			disable_lx: false,
			xmLxInput: '',
			xmConnector_1: '',
			xmLxSelect: '',
			dialogObj: {
				title: '选择适用单位',
				visible: false,
				width: '500px'
			}
		}
	},
	methods: {
		// 类型选择下拉框改变事件
		xmLxChange: function(event, index) {
			this.formDynamic.items[index].lxInput3Show =
				event === 'String' ? true : false
		},

		// 增加类别按钮事件
		handleAdd() {
			//弹窗中的点击增加类型
			if (this.index < 5) {
				this.index++
				this.formDynamic.items.push({
					index: this.index,
					status: 1,
					lxInput3Show: false,
					xmLxInput: '',
					xmLxSelect: '',
					xmConnector_1: '',
					typeList3: [
						{ value: '1', label: 'String' },
						{ value: '2', label: 'YYYY' },
						{ value: '3', label: 'MM' },
						{ value: '4', label: 'DD' }
					],
					connector3_1: [
						{ value: '1', label: '*' },
						{ value: '2', label: '/' },
						{ value: '3', label: '_' },
						{ value: '4', label: '+' },
						{ value: '5', label: '-' },
						{ value: '6', label: '#' }
					]
				})
			} else {
				this.$message.warning('类型节点最多只能添加5个')
			}
		},

		// 删除按钮事件
		handleRemove(index) {
			this.index--
			this.formDynamic.items[index].status = 0
		},

		// 选择适用单位按钮事件
		selectModal() {
			this.dialogObj.visible = true
		},

		// 选择适用单位
		selectDept(res) {
			if (res.length > 0) {
				this.formDynamic.parentIds = []
				this.formDynamic.parentName = ''
				for (let item of res) {
					this.formDynamic.parentIds.push(item.id)
					this.formDynamic.parentName += item.sname + ';'
				}
			}
			this.dialogObj.visible = false
		},

		// 选择适用单位确定按钮事件
		addDept() {
			this.$refs.selectDept.doSave()
		},

		// 点击确认,新增编码
		doSave() {
			this.$refs.codeForm.validate(valid => {
				if (valid) {
					this.$confirm('是否确定提交当前数据?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.formDynamic.detail = JSON.stringify(this.rules)
						this.formDynamic.companyId = this.formDynamic.parentIds.toString()
						saveSysCode(this.formDynamic).then(res => {
							res.operationCode == 1
								? this.$emit('on-success')
								: this.$message.error(res.msg)
						})
					})
				}
			})
		}
	},
	computed: {
		...mapState('dict', {
			typeList: state => state.gzlx, // 规则类型
			serialNoList: state => state.lshws // 流水号位数
		}),
        
		guize: function() {
			let that = this
			let getArr = []
			that.rules = []
			let arr = this.formDynamic.items
			for (var i = 0; i < arr.length; i++) {
				if (arr[i].status == 1) {
					if (arr[i].xmLxSelect == 'String') {
						getArr.push(arr[i].xmLxInput + arr[i].xmConnector_1)
						that.rules.push({
							type: arr[i].xmLxInput,
							connector: arr[i].xmConnector_1
						})
					} else {
						getArr.push(arr[i].xmLxSelect + arr[i].xmConnector_1)
						that.rules.push({
							type: arr[i].xmLxSelect,
							connector: arr[i].xmConnector_1
						})
					}
				}
			}
			that.rules.push({ serialNo: this.formDynamic.serialNo })
			return getArr.join('') + this.formDynamic.serialNo
		}
	}
}
</script>

<style lang="less">
.add-code-main {
	.el-input-group__prepend {
		border-right: none;
	}

	.el-input-group__append {
		background-color: #409eff;
		color: #fff;
		vertical-align: middle;
		display: table-cell;
		position: relative;
		border: 1px solid #dcdfe6;
		padding: 0 20px;
		width: 1px;
		white-space: nowrap;
		border-left: none;
	}
}
</style>
